import 'cropperjs/dist/cropper.css';
import * as ReactDOM from 'react-dom';
import { App } from './App';
import { maybeRedirectAzureCallback } from './utils/azureAuth';
import './index.css';

maybeRedirectAzureCallback();

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);
